import React, { useEffect, useState } from "react";
import { Play, X, ExternalLink, Loader2 } from "lucide-react";
import { api } from "@/api/client";
import { useI18n } from "@/i18n";
import { LoadError } from "@/components/LoadError";
import { Dialog, DialogContent } from "@/components/ui/dialog";

export default function Videos() {
  const { t } = useI18n();
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [active, setActive] = useState(null);

  const load = () => {
    setLoading(true);
    setError(false);
    api("/videos", { skipAuth: true })
      .then((r) => {
        const vids = r.videos || [];
        setVideos(vids);
        if (vids.length) localStorage.setItem("vhrp_last_video_seen", vids[0].video_id);
      })
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  if (loading) return <div className="flex min-h-[50vh] items-center justify-center"><Loader2 className="h-8 w-8 animate-spin text-brand" /></div>;
  if (error) return <LoadError onRetry={load} />;

  return (
    <div className="mx-auto max-w-6xl px-4 py-10">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-black text-ink">{t("videosTitle")}</h1>
        <a href="https://www.youtube.com/@VishwaHinduRakshaParishad" target="_blank" rel="noreferrer" className="flex items-center gap-1.5 rounded-full bg-[#FF0000] px-3 py-1.5 text-xs font-bold text-white">
          <Play size={13} fill="currentColor" /> YouTube
        </a>
      </div>

      {videos.length === 0 ? (
        <div className="py-24 text-center text-ink-muted">{t("videosEmpty")}</div>
      ) : (
        <div className="mt-6 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {videos.map((v) => (
            <button key={v.video_id} data-testid={`video-${v.video_id}`} onClick={() => setActive(v)} className="group text-left">
              <div className="relative overflow-hidden rounded-2xl">
                <img src={v.thumbnail} alt="" className="aspect-video w-full object-cover transition-transform group-hover:scale-105" />
                <span className="absolute left-1/2 top-1/2 flex h-12 w-12 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full border-2 border-white/80 bg-brand-deep/90 text-white">
                  <Play size={20} fill="currentColor" />
                </span>
              </div>
              <div className="mt-2 line-clamp-2 text-sm font-semibold text-ink">{v.title}</div>
            </button>
          ))}
        </div>
      )}

      <Dialog open={!!active} onOpenChange={(o) => !o && setActive(null)}>
        <DialogContent className="max-w-3xl overflow-hidden p-0">
          {active && (
            <div>
              <div className="aspect-video w-full">
                <iframe
                  title={active.title}
                  className="h-full w-full"
                  src={`https://www.youtube.com/embed/${active.video_id}?autoplay=1`}
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>
              <div className="flex items-center justify-between gap-3 p-4">
                <span className="line-clamp-2 text-sm font-semibold text-ink">{active.title}</span>
                <a href={active.watch_url} target="_blank" rel="noreferrer" className="flex items-center gap-1 whitespace-nowrap text-xs font-bold text-brand">
                  <ExternalLink size={13} /> YouTube
                </a>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}
